import styled from 'styled-components';

export const PlaceholderField = styled.p`
    font-size: 14px;
    opacity: 0.7;
`;
